import { NgbDateAdapter, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Injectable } from '@angular/core';
import * as moment from 'moment';

/**
 * This Service handles how the date is represented in scripts i.e. ngModel.
 */
@Injectable()
export class CustomAdapter extends NgbDateAdapter<string> {

  fromModel(value: string | null): NgbDateStruct | null {
    if (value) {
      const date = moment(value);

      return {
        day: date.date(),
        month: date.month() + 1,
        year: date.year()
      };
    }
    return null;
  }

  toModel(date: NgbDateStruct | null): string | null {
    return date ? moment({...date, month: date.month - 1}).toISOString() : null;
  }
}

/**
 * This Service handles how the date is rendered and parsed from keyboard i.e. in the bound input field.
 */
@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {

  readonly DELIMITER = '/';

  parse(value: string): NgbDateStruct | null {
    if (value) {
      const date = moment(value, 'DD/MM/yyyy');

      return {
        day: date.date(),
        month: date.month() + 1,
        year: date.year()
      };
    }
    return null;
  }

  format(date: NgbDateStruct | null): string {
    return date ? moment({...date, month: date.month - 1}).format('DD/MM/yyyy') : '';
  }
}


